<template>
  <div class="chat-app-form">
    <template v-if="gravando">
      <div class="d-flex align-items-center flex-grow-1 px-1">
        <span class="gravando-ponto mr-1"></span>
        <span>Gravando áudio... {{ duracaoFormatada }}</span>
      </div>
      <b-button variant="outline-secondary" class="mr-50" @click="cancelarGravacao">
        <feather-icon icon="XIcon" />
      </b-button>
      <b-button variant="danger" @click="pararGravacao">
        <feather-icon icon="CheckIcon" />
      </b-button>
    </template>
    <template v-else>
      <input ref="inputArquivo" type="file" class="d-none" @change="aoSelecionarArquivo" />
      <b-button variant="flat-secondary" class="mr-50" :disabled="desabilitado" @click="escolherArquivo" title="Anexar arquivo">
        <feather-icon icon="PaperclipIcon" />
      </b-button>
      <b-form class="flex-grow-1" @submit.prevent="enviar">
        <b-input-group class="input-group-merge form-send-message mr-1">
          <textarea
            v-model="texto"
            cols="30"
            rows="1"
            class="form-control mr-1 mt-1 mb-1"
            :disabled="desabilitado"
            placeholder="Digite uma mensagem..."
            @keydown.enter.exact.prevent="enviar"
          ></textarea>
        </b-input-group>
      </b-form>
      <b-button v-if="!texto.trim()" variant="flat-secondary" class="mr-50" :disabled="desabilitado" @click="iniciarGravacao" title="Gravar áudio">
        <feather-icon icon="MicIcon" />
      </b-button>
      <b-button
        variant="primary"
        :disabled="desabilitado || !texto.trim()"
        @click="enviar"
      >
        <feather-icon icon="SendIcon" />
      </b-button>
    </template>
  </div>
</template>

<script>
import { BForm, BInputGroup, BButton } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
  components: { BForm, BInputGroup, BButton, FeatherIcon },
  props: {
    desabilitado: { type: Boolean, default: false },
  },
  data() {
    return {
      texto: "",
      gravando: false,
      duracaoSegundos: 0,
      timerDuracao: null,
      mediaRecorder: null,
      chunksAudio: [],
      streamAtual: null,
    };
  },
  computed: {
    duracaoFormatada() {
      const minutos = String(Math.floor(this.duracaoSegundos / 60)).padStart(2, "0");
      const segundos = String(this.duracaoSegundos % 60).padStart(2, "0");
      return minutos + ":" + segundos;
    },
  },
  beforeDestroy() {
    this.pararStream();
  },
  methods: {
    enviar() {
      const valor = this.texto.trim();
      if (!valor || this.desabilitado) return;
      this.$emit("enviar", valor);
      this.texto = "";
    },
    escolherArquivo() {
      this.$refs.inputArquivo.click();
    },
    aoSelecionarArquivo(evento) {
      const arquivo = evento.target.files[0];
      evento.target.value = "";
      if (!arquivo) return;
      this.$emit("enviar-arquivo", { arquivo, legenda: this.texto.trim() || null });
      this.texto = "";
    },
    async iniciarGravacao() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message(null, "Este navegador não suporta gravação de áudio", "error");
        return;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.streamAtual = stream;
        this.chunksAudio = [];
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.ondataavailable = (evento) => {
          if (evento.data && evento.data.size > 0) this.chunksAudio.push(evento.data);
        };
        this.mediaRecorder.onstop = this.aoFinalizarGravacao;
        this.mediaRecorder.start();
        this.gravando = true;
        this.duracaoSegundos = 0;
        this.timerDuracao = setInterval(() => { this.duracaoSegundos++; }, 1000);
      } catch (erro) {
        this.$message(null, "Não foi possível acessar o microfone", "error");
      }
    },
    pararGravacao() {
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.cancelado = false;
        this.mediaRecorder.stop();
      }
    },
    cancelarGravacao() {
      this.cancelado = true;
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.mediaRecorder.stop();
      } else {
        this.finalizarEstadoGravacao();
      }
    },
    aoFinalizarGravacao() {
      this.pararStream();
      if (!this.cancelado && this.chunksAudio.length) {
        const blob = new Blob(this.chunksAudio, { type: "audio/webm" });
        const arquivo = new File([blob], "audio.webm", { type: "audio/webm" });
        this.$emit("enviar-arquivo", { arquivo, legenda: null });
      }
      this.finalizarEstadoGravacao();
    },
    finalizarEstadoGravacao() {
      clearInterval(this.timerDuracao);
      this.gravando = false;
      this.duracaoSegundos = 0;
      this.chunksAudio = [];
    },
    pararStream() {
      if (this.streamAtual) {
        this.streamAtual.getTracks().forEach((faixa) => faixa.stop());
        this.streamAtual = null;
      }
    },
  },
};
</script>

<style scoped>
.gravando-ponto {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ea5455;
  display: inline-block;
  animation: pulsar 1s infinite;
}
@keyframes pulsar {
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
}
</style>
